import { Controller } from 'stimulus';
import Swiper, { Pagination, EffectFade, Navigation } from 'swiper';

class CardsCarousel extends Controller {

  connect() {
    // Cards carousel
    Swiper.use([Pagination, EffectFade, Navigation]);

    const _this = this;
    this.swiper = new Swiper('.swiper-card-slider', {
      autoplay: {
        delay: 5000,
      },
      grabCursor: true,
      loop: false,
      loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-card-slider-pagination',
        bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-secondary',
        bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-active-secondary',
        clickable: true,
      },
      spaceBetween: 16,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      slideVisibleClass: 'swiper-slide-visible',
      slidePrevClass: 'swiper-slide-prev',
      slideNextClass: 'swiper-slide-next',
      breakpoints: {
        768: {
          slidesPerGroup: 2,
          spaceBetween: 32,
        },

        920: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
        },

        1280: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
        },
      },
      on: {
        init: function() {
          _this.arrowWidth();
        },
        resize: function() {
          _this.arrowWidth();
        }
      }
    }); // swiper close
  }

  arrowWidth() {
    console.log('arrow widths');

    const controllerW = this.element.offsetWidth,
          sliderW     = this.sliderTarget.offsetWidth,
          diff        = (controllerW - sliderW) / 2;

    const minW = 16 * 4;

    let arrowW      = diff,
        arrowOffset = 0;

    if(minW > diff) {
      console.log('keep elements position');
      arrowW = minW;
      arrowOffset = minW - diff;
    }

    console.log(diff, minW, arrowW);

    this.element.style.setProperty('--arrow-width', arrowW + 'px');
    this.element.style.setProperty('--arrow-offset', arrowOffset + 'px');
  }
}

CardsCarousel.targets = ['slider'];

export default CardsCarousel;